import type { SVGProps } from 'react';

const SvgCentralizedTexting = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
    <g fill={props.color} data-name="centralized-texting">
      <path d="m28.34 7.22-1.06 1.06 1.93 1.93H17.86a2.72 2.72 0 0 0-2.72 2.72V18a1.22 1.22 0 0 1-1.22 1.22H2.79l1.93-1.93-1.06-1.06-3.21 3.21a.75.75 0 0 0 0 1.06l3.21 3.21 1.06-1.06-1.93-1.93h11.13A2.72 2.72 0 0 0 16.64 18v-5.07a1.22 1.22 0 0 1 1.22-1.22h11.35l-1.93 1.93 1.06 1.06 3.21-3.21a.75.75 0 0 0 0-1.06Z" />
      <path d="M6.8 22.27V29a2.7 2.7 0 0 0 2.7 2.7h13.13a2.7 2.7 0 0 0 2.7-2.7V13.18h-1.5V29a1.2 1.2 0 0 1-1.2 1.2H9.5A1.2 1.2 0 0 1 8.3 29v-6.73ZM25.33 8.84V3a2.7 2.7 0 0 0-2.7-2.7H9.5A2.7 2.7 0 0 0 6.8 3v14.61h1.5V3a1.2 1.2 0 0 1 1.2-1.2h13.13a1.2 1.2 0 0 1 1.2 1.2v5.84Z" />
      <path d="M13.45 26.84h4.96v1.5h-4.96z" />
    </g>
  </svg>
);

export default SvgCentralizedTexting;
